import type { SwiperOptions } from "swiper/types";

export const swiperOptions: SwiperOptions = {
    spaceBetween: 40,

    breakpoints: {
        319: {
            slidesOffsetAfter: 20,

            spaceBetween: 40,
        },
        464: {
            slidesOffsetAfter: 48,
        },
        984: {
            slidesOffsetAfter: 80,
        },
        1439: {
            slidesOffsetAfter: 0,
        },

        2559: {
            spaceBetween: 53,
        },
        3839: {
            spaceBetween: 79,
        },
    },
};
